import type { Translation } from "@/i18n/locales/types";

export const home: Translation["home"] = {
  title: "Home",
  greeting: {
    morning: "Good morning, {{name}}",
    afternoon: "Good afternoon, {{name}}",
    evening: "Good evening, {{name}}",
  },
  attention: {
    title: "Needs attention",
    description: "Denials and blocks from the last 7 days.",
    allClear: "Nothing pending. All good.",
    expiring_one: "{{name}} expires {{when}} ({{issuer}})",
    expiring_other: "{{name}} expires {{when}} ({{issuer}})",
    noValidVersion: "{{name}} has no valid version and does not sign",
    blockedSpike_one: "{{count}} request blocked on {{host}}",
    blockedSpike_other: "{{count}} requests blocked on {{host}}",
    blockedSpikePolicy_one:
      "{{count}} request blocked on {{host}} by “{{policy}}”",
    blockedSpikePolicy_other:
      "{{count}} requests blocked on {{host}} by “{{policy}}”",
    signatureSpike_one: "{{count}} signature denied on {{host}}",
    signatureSpike_other: "{{count}} signatures denied on {{host}}",
    signatureSpikePolicy_one:
      "{{count}} signature denied on {{host}} by “{{policy}}”",
    signatureSpikePolicy_other:
      "{{count}} signatures denied on {{host}} by “{{policy}}”",
    deniedSignatures_one: "{{count}} signature denied",
    deniedSignatures_other: "{{count}} signatures denied",
    staleInvites_one:
      "{{count}} invitation not accepted for more than {{days}} days",
    staleInvites_other:
      "{{count}} invitations not accepted for more than {{days}} days",
    replace: "Replace",
    see: "View",
  },
  steps: {
    title: "Getting started",
    description: "This disappears once everything is done.",
    done: "Done:",
    pending: "Pending:",
    items: {
      certificate: "Add a certificate",
      invite: "Invite your team",
      policy: "Create a policy",
      mac: "Install the Mac app",
    },
  },
  recent: {
    title: "Last 7 days",
    signatures: "Signatures",
    denied: "Denied",
    activePeople: "Active people",
  },
};
